export const FETCH_ROLE = 'FETCH_ROLE';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_ERROR = 'FETCH_ROLE_ERROR';

export const fetchRoleAction = (payload) => {
    return (
        {
            type: FETCH_ROLE,
            payload,
        });
};

export const fetchRoleSuccessAction = (role) => (
    {
        type: FETCH_ROLE_SUCCESS,
        role,
    }
);

export const fetchRoleErrorAction = (error) => (
    {
        type: FETCH_ROLE_ERROR,
        error,
    }
);

const initialState = {
    fetching: false,
    roles: [],
    error: null,
};

export function roleReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ROLE:
            return {
                ...state,
                fetching: true,
                error: null,
            };

        case FETCH_ROLE_SUCCESS:
            return {
                ...state,
                fetching: false,
                roles: action.role.roles,
                error: null,
            };

        case FETCH_ROLE_ERROR:
            return {
                ...state,
                fetching: false,
                error: action.error,
            };

        default:
            return state;
    }
}